// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Utils = require("../../utils/Utils.bs.js");
let IconV5 = require("../../uikit/atoms/Icon/IconV5.bs.js");
let ViewStack = require("../../reason/common/ViewStack.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let FragmentErrorBoundary = require("../common/ErrorHandling/FragmentErrorBoundary.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let RentalNeedPropertyAttributes_rentalNeedV5_graphql = require("../../__generated__/RentalNeedPropertyAttributes_rentalNeedV5_graphql.bs.js");

let convertFragment = RentalNeedPropertyAttributes_rentalNeedV5_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, RentalNeedPropertyAttributes_rentalNeedV5_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(RentalNeedPropertyAttributes_rentalNeedV5_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, RentalNeedPropertyAttributes_rentalNeedV5_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(RentalNeedPropertyAttributes_rentalNeedV5_graphql.node, convertFragment, fRef);
}

let Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function RentalNeedPropertyAttributes(props) {
  let __icon = props.icon;
  let icon = __icon !== undefined ? Primitive_option.valFromOption(__icon) : "home";
  let match = RescriptRelay_Fragment.useFragment(RentalNeedPropertyAttributes_rentalNeedV5_graphql.node, convertFragment, props.rentalNeed);
  let minBeds = match.minBeds;
  let __x = match.propertyTypes.map(x => x.displayName);
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
    fragmentDisplayName: "property criteria",
    children: JsxRuntime.jsxs(ViewStack.make, {
      flexDirection: "row",
      children: [
        JsxRuntime.jsxs(ViewStack.make, {
          space: "sm",
          flexDirection: "row",
          children: [
            Stdlib_Option.getOr(Stdlib_Option.map(icon, icon => JsxRuntime.jsx(IconV5.make, {
              icon: icon,
              className: "text-zinc-600"
            })), null),
            JsxRuntime.jsx("span", {
              children: Utils.$$Array.pseudoJoin(", ", " or ", __x).join(""),
              className: "text-zinc-700"
            })
          ]
        }),
        minBeds !== undefined ? JsxRuntime.jsxs(ViewStack.make, {
            space: "sm",
            flexDirection: "row",
            children: [
              JsxRuntime.jsx(IconV5.make, {
                icon: "bed",
                className: "relative top-0.5 text-zinc-600"
              }),
              JsxRuntime.jsx("span", {
                children: minBeds.toString() + `+`,
                className: "text-zinc-700"
              })
            ]
          }) : null
      ]
    })
  });
}

let make = RentalNeedPropertyAttributes;

exports.Fragment = Fragment;
exports.make = make;
/* Utils Not a pure module */
